import React from 'react';
import { getProductMix } from '../../services/api';
import { ReportPage, formatMoney } from './ReportPage';
import { useReport } from './useReport';

const LIST_SIZE = 5;

const ProductList = ({ title, products, money }) => (
  <div className="report-card">
    <h3 className="report-card-title">{title}</h3>
    <ol className="report-products">
      {products.map((p) => (
        <li key={p.product_id}>
          <span className="report-product-name">{p.name}</span>
          <span className="report-product-qty">{p.quantity} sold</span>
          <strong>{money(p.net_sales)}</strong>
        </li>
      ))}
    </ol>
  </div>
);

const ProductMix = ({ restaurants, userId, authenticatedFetch, currencies }) => {
  const report = useReport(getProductMix, { restaurants, userId, authenticatedFetch });

  return (
    <ReportPage report={report}>
      {(groups) => groups.map(({ currency, products, unsold = [] }) => {
        const currencyKey = currencies.find((c) => c.value === currency)?.key;
        const money = (value) => formatMoney(value, currencyKey);
        // Products come ranked by net sales: the rest is ranked again so the lists never overlap.
        const weakest = products.slice(LIST_SIZE).slice(-LIST_SIZE).reverse();

        return (
          <section key={currency} className="report-section">
            {currencyKey && <h2 className="report-currency">{currencyKey}</h2>}
            <div className="report-cards">
              {products.length > 0 && (
                <ProductList title="Top sellers" products={products.slice(0, LIST_SIZE)} money={money} />
              )}
              {weakest.length > 0 && <ProductList title="Weakest sellers" products={weakest} money={money} />}
              {unsold.length > 0 && <ProductList title="Unsold this period" products={unsold} money={money} />}
            </div>
          </section>
        );
      })}
    </ReportPage>
  );
};

export default ProductMix;
